var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.healthData)?_c('production-chart',{key:_vm.healthData.id,attrs:{"graph-data":_vm.healthData.seriesData,"x-axis-rotate":90,"legend":false,"only-percent":true}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }